<template>
  <div class="route-is-expanded p-3">
    <ul>
      <template v-for="point in route.points">
        <div v-bind:key="point.index">
          <li>
            <div class="route-place">
              <div class="route-time">
                <p v-if="point.arrivalTime" class="text-right">
                  <span class="font-bold">{{ point.arrivalTime.format('HH:mm') }}</span>
                  <span class="text-sm pl-1">{{ $t('tour_arrival_time_label') }}</span>
                </p>
                <p v-if="point.departureTime" class="text-right">
                  <span class="font-bold">{{ point.departureTime.format('HH:mm') }}</span>
                  <span class="text-sm pl-1">{{ $t('tour_departure_time_label') }}</span>
                </p>
              </div>
              <div class="route-name text-body ml-2 break-all">
                {{ point.name }}
                <div v-if="point.pole">
                  {{ $t('tour_platform') }} {{point.pole.no}}
                </div>
              </div>
              <div class="plan-icon ml-1 mr-2">
                <a @click="showMap(point)" class="text-link">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.18746 8.81266L3.40381 10.4691C3.13624 10.5458 2.93311 10.7643 2.87617 11.0367L0.741076 21.2527C0.628783 21.79 1.11277 22.262 1.64707 22.1362L8.62341 20.494C8.73747 20.4671 8.85623 20.4674 8.97017 20.4947L15.1435 21.9751C15.2547 22.0018 15.3705 22.0026 15.4821 21.9777L22.7578 20.3501C23.1599 20.2601 23.4141 19.8625 23.3271 19.4597L21.2569 9.88016C21.1676 9.46677 20.7543 9.20896 20.3438 9.31052L15.3628 10.5427C15.2278 10.5761 15.0861 10.5713 14.9537 10.5288L9.62297 8.81949C9.48167 8.77418 9.33011 8.77181 9.18746 8.81266Z" class="icon-fill" />
                  <path d="M9.00002 10L3.75002 11.625L2.06252 20.8125L8.31252 19.3125L9.00002 10Z" fill="white"/>
                  <path d="M14.7969 11.5625L9.6875 9.78125L9.125 19.3438L14.7969 20.6094V11.5625Z" fill="white"/>
                  <path d="M20.3125 10.5C20.3125 10.5 15.6094 11.5625 15.5469 11.5625V20.7188L21.9844 19.1875L20.3125 10.5Z" fill="white"/>
                  <path d="M11.75 1C14.3755 1 16.5 3.11863 16.5 5.73685C16.5 6.3012 16.4351 6.88405 16.1938 7.39289L12.8169 14.5537C12.6221 14.9607 12.1953 15.2105 11.75 15.2105C11.3047 15.2105 10.8779 14.9607 10.6924 14.5537L7.30615 7.39289C7.06494 6.88405 7 6.3012 7 5.73685C7 3.11863 9.12451 1 11.75 1V1ZM11.75 3.36842C10.5107 3.36842 9.5 4.40508 9.5 5.67612C9.5 6.94715 10.5107 7.98381 11.75 7.98381C12.9893 7.98381 14 6.94715 14 5.67612C14 4.40508 12.9893 3.36842 11.75 3.36842V3.36842Z" class="icon-fill" />
                  </svg>
                </a>
              </div>
            </div>
          </li>
          <li v-if="point.line">
            <div class="route-transport">
              <div class="route-schedule text-sm text-center pt-4 pr-3">
                ({{ point.line.duration + $t('tour_minute_label') }})
              </div>
              <div class="route-color" :style="{ backgroundColor: rgb(point.line.color) }"></div>
              <div class="route-vehicle">
                <p class="route-icon py-4">
                  <line-icon :line=point.line />
                </p>
                <div class="route-vehicle-name py-4 pl-1 text-body">
                  <p>{{ point.line.name }}</p>
                </div>
              </div>
            </div>
          </li>
        </div>
      </template>
    </ul>
  </div>
</template>

<script>
import LineIcon from "../atoms/LineIcon"
import Constants from "../../constants"

export default {
  components: {
    LineIcon
  },
  props: {
    route: {
      type: Object,
      required: true
    }
  },
  methods: {
    rgb: function (digit) {
      const r = digit.slice(0, 3)
      const g = digit.slice(3, 6)
      const b = digit.slice(6, 9)
      const s = 'rgb(' + [r, g, b].join(', ') + ')'
      return s
    },
    showMap: function (point) {
      const location = point.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      if (point.pole) {
        const poleData = Constants.SENDAI_STA_POLE.find((s) => s.no == point.pole.no)
        if (poleData) {
          const zoomLevel = '19'
          this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'], poiId: poleData.poi_id, zoom: zoomLevel} })
          return
        }
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$router.push({ name: 'map', params: { lang: this.$store.getters['user/getLang'] } })
    }
  }
}
</script>
